import { stack } from './stack';
import { column } from './column';
export const CalendarEventOverlapModes = {
  stack,
  column
};
//# sourceMappingURL=index.js.map